export type AppEnvironment = 'development' | 'production'

export function getEnvironment(): AppEnvironment {
  if (typeof import.meta !== 'undefined' && import.meta.env?.DEV) {
    return 'development'
  }
  return 'production'
}

export function isDevelopment(): boolean {
  return getEnvironment() === 'development'
}

export function isProduction(): boolean {
  return getEnvironment() === 'production'
}

export function getEnvVar(name: string): string | undefined {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[name] as string | undefined
  }
  return undefined
}

export function stripTrailingSlashes(url: string): string {
  return url.replace(/\/+$/, '')
}
